namespace Nobox {
    export interface ChatroomsCreateForm {
        Chat: TypeChatConversation;
        Channel: Serenity.ServiceLookupEditor;
        Account: Serenity.ServiceLookupEditor;
        To: Serenity.RadioButtonEditor;
        Contact: Serenity.ServiceLookupEditor;
        Link: Serenity.ServiceLookupEditor;
        Manual: Serenity.StringEditor;
        Group: Serenity.ServiceLookupEditor;
        FormTemplateId: Serenity.StringEditor;
        FormResultId: Serenity.StringEditor;
    }

    export class ChatroomsCreateForm extends Serenity.PrefixedContext {
        static formKey = 'Chat.ChatCreaterooms';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ChatroomsCreateForm.init)  {
                ChatroomsCreateForm.init = true;

                var s = Serenity;
                var w0 = TypeChatConversation;
                var w1 = s.ServiceLookupEditor;
                var w2 = s.RadioButtonEditor;
                var w3 = s.StringEditor;

                Q.initFormType(ChatroomsCreateForm, [
                    'Chat', w0,
                    'Channel', w1,
                    'Account', w1,
                    'To', w2,
                    'Contact', w1,
                    'Link', w1,
                    'Manual', w3,
                    'Group', w1,
                    'FormTemplateId', w3,
                    'FormResultId', w3
                ]);
            }
        }
    }
}
